import Migration from './migration'

import Logger from '@/logger'

export default class M002 extends Migration {

    constructor() {
        super('M002 - Remove Key Metric',
            async(authContext) => {
                try {
                    await this.removeAsync('preferences', authContext)
                } catch {
                    Logger.log('No preferences data to clear')
                }
            })
    }
}
